module.exports = __webpack_public_path__ + "img/Workday.44c4e24c.svg";